import {
  BG_STYLES,
  COMMON_STYLES,
  TEXT_STYLES,
  TYPOGRAPHY,
  VARIANTS_STYLES,
} from '@dehaat/dds'
import React from 'react'
import { Text, View } from 'react-native'

interface Props {
  orderId: string
  orderDate: string
  address: string
  paymentMethod: string
}

interface OrderRowProps {
  name: string
  value: string
}

const OrderRow = ({ name, value }: OrderRowProps) => {
  return (
    <View
      style={[
        COMMON_STYLES.flex1,
        COMMON_STYLES.row,
        COMMON_STYLES.mt1,
        COMMON_STYLES.alignItemsCenter,
        COMMON_STYLES.justifyBetween,
      ]}
    >
      <Text
        style={[
          TYPOGRAPHY.TEXT2,
          VARIANTS_STYLES.BASE,
          TEXT_STYLES.textNeutral70,
        ]}
      >
        {name}
      </Text>
      <Text
        style={[
          TEXT_STYLES.textNeutral80,
          TYPOGRAPHY.TEXT1,
          VARIANTS_STYLES.MEDIUM,
        ]}
      >
        {value}
      </Text>
    </View>
  )
}

const ShipingDetail = ({
  orderDate,
  orderId,
  address,
  paymentMethod,
}: Props) => {
  return (
    <View style={[COMMON_STYLES.ph2, COMMON_STYLES.pv1, BG_STYLES.bgWhite]}>
      <Text
        style={[
          TYPOGRAPHY.HEADING3,
          VARIANTS_STYLES.EMPHASIZED,
          TEXT_STYLES.textNeutral90,
        ]}
      >
        Order Details
      </Text>
      <OrderRow name={'Order id'} value={orderId} />
      <OrderRow name="Payment Method" value={paymentMethod} />
      <View
        style={[
          COMMON_STYLES.flex1,
          COMMON_STYLES.row,
          COMMON_STYLES.mt1,
          COMMON_STYLES.alignItemsCenter,
          COMMON_STYLES.justifyBetween,
        ]}
      >
        <Text
          style={[
            TYPOGRAPHY.TEXT2,
            VARIANTS_STYLES.BASE,
            TEXT_STYLES.textNeutral70,
          ]}
        >
          Deliver to
        </Text>
        <Text
          style={[
            TEXT_STYLES.textNeutral80,
            TYPOGRAPHY.TEXT1,
            VARIANTS_STYLES.MEDIUM,
            { textAlign: 'right' },
            COMMON_STYLES.flexWrap,
          ]}
        >
          {address}
        </Text>
      </View>
      <OrderRow name="Order placed" value={`Placed on ${orderDate}`} />
    </View>
  )
}

export default ShipingDetail
